module.exports = __webpack_public_path__ + "static/media/gal-12.1d271b7d.jpeg";